{
    "account": "Konto",
    "add_bookmark": "Nachricht zu den Lesezeichnen hinzufügen",
    "add_date": "Ein Datum hinzufügen",
    "ago": "Vor {{duration}}",
    "api_key": "API-Schlüssel",
    "are_you_sure": "Bist du sicher?",
    "ask_delete_message": "Diese Nachricht löschen?",
    "audio_not_ready": "Audio ist noch nicht fertig.",
    "bookmark_added": "Nachricht zu den Lesezeichen hinzugefügt.",
    "bookmark_removed": "Nachricht aus den Lesezeichen entfernt.",
    "bookmarks": "Lesezeichen",
    "cancel": "Abbrechen",
    "cancel_write": "Willst du das Schreiben einer neuen Nachricht wirklich abbrechen?",
    "changed_group_name": "hat den Gruppenamen geändert",
    "confirm_password_placeholder": "Passwort bestätigen",
    "connect": "Verbindung",
    "create_a_group": "Eine Gruppe erstellen",
    "create_the_group": "Die Gruppe erstellen",
    "daily": "Täglich",
    "default_group": "Standard-Gruppe",
    "delete": "Löschen",
    "destroy_account": "Dein Konto löschen",
    "destroy_account_explain": "Wenn du dein Konto einmal gelöscht hast, gibt es keinen Weg zurück. Bitte sei sicher.",
    "edit": "Bearbeiten",
    "email": "E-Mail",
    "email_input": "Gib hier deine E-Mail-Adresse ein",
    "empty_message": "Die Nachricht ist leer und kann nicht gesendet werden.",
    "error": "Ein Fehler ist aufgetreten",
    "error_new_message": "Beim Senden deiner Nachricht ist ein Fehler aufgetreten.",
    "error_upload": "Beim Hochladen ist ein Fehler aufgetreten",
    "forgot_password": "Passwort vergessen?",
    "group_left": "Du hast die Gruppe verlassen.",
    "groups": "Gruppen",
    "group_share_choice": "An welche Gruppe möchtest du diese Nachricht senden?",
    "group_updated": "Die Gruppe wurde aktualisiert.",
    "has_commented_on": "hat kommentiert",
    "has_joined": "ist beigetreten",
    "has_left": "hat verlassen",
    "has_posted_in": "hat veröffentlicht in",
    "hourly": "Stündlich",
    "in": "in",
    "Invalid login/password": "Ungültiges Benutzername oder Passwort",
    "invitation_link": "Einladungslink",
    "invitation_welcome": "Willkommen bei Zusam. Bitte melde dich an, bevor du der Gruppe beitrittst.",
    "just_now": "Gerade jetzt",
    "lang": "Sprache",
    "login": "Anmelden",
    "login_input": "Wähle einen Benutzername",
    "login_placeholder": "E-Mail",
    "logout": "Abmelden",
    "mark_all_as_read": "alle als gelesen markieren",
    "monthly": "Monatlich",
    "multiple_photos_upload": "Ein Fehler ist aufgetreten. Versuche, die Bilder nacheinander hochzuladen (dies kann bei einigen Browsern vorkommen)",
    "name_input": "Wähle einen Namen",
    "name": "Name",
    "new_password_placeholder": "Neues Passwort",
    "next_coms": "Nächste Kommentare ansehen",
    "none": "Keine",
    "notification_emails": "E-Mail-Benachrichtigungen",
    "notification_emails_stopped": "E-Mail-Benachrichtigungen gestoppt!",
    "notifications": "Benachrichtigungen",
    "parent_message": "Quellenachricht",
    "password_input": "Gib hier ein neues Passwort ein",
    "password": "Passwort",
    "password_placeholder": "Passwort",
    "password_reset_mail_sent": "Die E-Mail zum Zurücksetzen des Passworts findest du in deinem Posteingang.",
    "passwords_dont_match": "Passwörter stimmen nicht überein",
    "previous_coms": "Vorherige Kommentare ansehen",
    "public_link": "öffentlicher Link",
    "publish_in_group": "in der Gruppe veröffentlichen",
    "quit_group": "Die Gruppe verlassen",
    "remove_bookmark": "Nachricht aus den Lesezeichnen entfernen",
    "replies_one": "{{count}} Antwort",
    "replies_other": "{{count}} Antworten",
    "reply": "antworten",
    "reset_api_key": "Setze den API-Schlüssel zurück (die Verbindung wird unterbrochen)",
    "reset_invitation_link": "Einladungslink zurücksetzen",
    "reset_password_title": "Dein Passwort zurücksetzen",
    "save_changes": "Änderungen speichern",
    "search_in_group": "in dieser Gruppe suchen",
    "search_without_result": "Deine Suche hat zu keiner Nachricht geführt.",
    "settings": "Einstellungen",
    "settings_updated": "Deine Einstellungen wurden aktualisiert",
    "share_message": "die Nachricht teilen",
    "signup": "Registrieren",
    "submit": "Senden",
    "text_placeholder": "Schreibe deine Nachricht hier",
    "the_message_from": "die Nachricht von",
    "title_placeholder": "Titel deiner Nachricht (optional)",
    "to": "zu",
    "upload_audio": "Audio hinzufügen.",
    "upload_image": "Fotos hinzufügen",
    "upload_music": "Musik hinzufügen",
    "upload_pdf": "PDF hinzufügen",
    "upload_video": "Video hinzufügen",
    "User not found": "Benutzer nicht gefunden",
    "users": "Benutzer",
    "video_not_ready": "Das Video ist noch nicht fertig.",
    "weekly": "Wöchentlich"
}
